module.exports = __webpack_public_path__ + "img/obs_snow_0_over.4a4c3b36.svg";